module.exports = "<topnav></topnav>\n\n<app-sidenav></app-sidenav>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.html
// module id = ./src/app/layout/layout.html
// module chunks = main